import { on, reducer } from 'ts-action';
import * as undoActions from '../../undo/actions/undo.actions';
import * as toolActions from '../actions/tool.actions';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import { Tool } from '../utils/tool.utils';

export interface ToolState {
  activeTool: Tool | null;
}

declare module 'react-redux' {
  interface DefaultRootState {
    tool: ToolState;
  }
}

const initialStateFactory = (): ToolState => ({
  activeTool: null,
});

export default reducer(
  initialStateFactory(),
  on(
    toolActions.setActiveTool,
    (state, { tool }): ToolState => ({
      ...state,
      activeTool: tool,
    }),
  ),
  on(undoActions.undo, undoActions.restore, (state, { diff: { tool } }) => {
    if (!tool) {
      return state;
    }
    return { ...state, ...tool };
  }),
  on(ecgActions.clean, initialStateFactory),
);
